import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    height: '100%',
    alignContent: 'center',
  },
  cardSelected: {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    border: `1.5px solid ${theme.palette.primary.hover}`,
    backgroundColor: theme.palette.custom.light,
    transition: 'box-shadow 0.3s, border-color 0.3s, background-color 0.3s',
  },
  square: {
    borderRadius: 4,
    padding: 12,
    lineHeight: 0,
  },
  hexagon: {
    clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
    aspectRatio: '1',
    paddingBlock: 12,
    paddingInline: 10,
    lineHeight: 0,
  },
  contentBox: {
    textTransform: 'uppercase',
  },
  caption: {
    fontWeight: 600,
  },
  cardActionArea: {
    height: '100%',
  },
  isLoading: {
    opacity: 0.5,
    backgroundColor: theme.palette.action.disabledBackground,
  },
}))

export default styles
